import Vue from 'vue'
import _ from 'lodash'
import VueLodash from 'vue-lodash'
import BootstrapVue from 'bootstrap-vue'
// import './plugins/vuetify'
// import infiniteScroll from 'vue-infinite-scroll'
// import VueVirtualScroller from 'vue-virtual-scroller' // { RecycleScroller }
import VirtualList from 'vue-virtual-scroll-list'
import VuePerfectScrollbar from 'vue2-perfect-scrollbar'
// import VVirtualScroll from 'vuetify/src/components/VVirtualScroll'

/*--- Assets ---*/
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
// import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
/*-----------------------------------------------*/

import TitleLine from 'Components/common/TitleLine'

Vue.use(VuePerfectScrollbar)
Vue.use(BootstrapVue)
Vue.use(VueLodash, { name: '$_', lodash: _ })
// Vue.component('RecycleScroller', RecycleScroller)
// Vue.use(infiniteScroll)

/* const GlobalComponents = {
  install(Vue) {
    Vue.component('TitleLine', TitleLine)
    // Vue.component('vuePerfectScrollbar', VuePerfectScrollbar)
    Vue.component('virtual-list', VirtualList)
    // Vue.component('VVirtualScroll', VVirtualScroll)
  },
}
Vue.use(GlobalComponents) */

Vue.component('TitleLine', TitleLine)
Vue.component('virtual-list', VirtualList)

Vue.config.productionTip = false

/* new Vue({
  render: (h) => h(App),
}).$mount('#app') */
